import { createFileRoute } from '@tanstack/react-router';

import { ReviewSearchClaimable } from '@/module/Author/Review/ReviewSearchClaimable';

export const Route = createFileRoute('/_auth/author/_author/review/_review/search-claimable')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <ReviewSearchClaimable />;
}
